import { render, staticRenderFns } from "./case.vue?vue&type=template&id=6152b6de&scoped=true&"
import script from "./case.vue?vue&type=script&lang=js&"
export * from "./case.vue?vue&type=script&lang=js&"
import style0 from "./case.vue?vue&type=style&index=0&id=6152b6de&prod&lang=css&"
import style1 from "./case.vue?vue&type=style&index=1&id=6152b6de&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6152b6de",
  null
  
)

export default component.exports